<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1 data-automation-name="eventPollHistory">Event Poll History for {{ven_id}}</h1>
      <p class="lead">
        This table contains entries for each venway-scheduler polling job runs.
      </p>
    </div>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading Poll History...">
    </app-loader>
  } @else {
    <table class="table table-striped">
      <thead>
      <tr>
        <th>Job Run Time</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
        @for(pollHistory of displayedEventPollHistories | paginate: paginationModel; track pollHistory) {
          <tr class="table-active">
            <td>{{pollHistory.dttm}}</td>
            <td>{{pollHistory.status}}</td>
          </tr>
        }
        @if(displayedEventPollHistories.length === 0) {
          <tr>
            <td colspan="2" style="text-align: center;">No history yet for the VEN</td>
          </tr>
        }
      </tbody>
      <tfoot>
      <tr>
        <td class="text-center" colspan="2">
          <pagination-controls
            [id]="paginationId"
            (pageChange)="handlePageChange($event)"
            class="my-pagination">
          </pagination-controls>
        </td>
      </tr>
      </tfoot>
    </table>
  }
</div>
